import { SUB_DOMAIN } from '@/constants';
import { useDeviceInfoStore } from '@/stores/DeviceStore';

import { useCheckPartnerWebview } from './useCheckPartnerWebview';

export const useIsOutsideWelloChannel = () => {
  const isPartnerWebview = useCheckPartnerWebview();
  const isKbPay = useDeviceInfoStore(
    (state) => state.subDomain === SUB_DOMAIN.KB_PAY,
  );

  return isPartnerWebview || isKbPay;
};
